import React, { useEffect, useState } from 'react';
import PageHeader from '../../PageHeader/PageHeader';
import StatisticsCard from '../../components/Cards/StatisticsCard';
import { Armchair, CheckCircle, QrCode, User } from 'lucide-react';
import { HitApi } from '../../Api/ApiHit';
import { legendItems, searchSeat } from '../../constant/Constant';
import { useDispatch, useSelector } from 'react-redux';
import { setFloorJson } from '../../redux/Actions/FloorAction';
import { SeatSubscription } from '../../apollo/SeatSubscription';
import SeatCard from './SeatCard';
import { isObjectEmpty } from '../../utils/utils';

export default function FloorMaster() {

  const FloorReducer = useSelector((state) => state.FloorReducer);
  const seats = FloorReducer?.doc ?? [];

  const getCount = (status) => {
    return Array.isArray(seats) ? seats.filter(seat => seat.status === status).length : 0;
  };

  const statsData = [
    {
      title: "Total Seats",
      count: seats.length,
      icon: <Armchair className="w-6 h-6 text-white" />,
      color: "gray",
    },
    {
      title: "Available",
      count: getCount("Available"),
      icon: <CheckCircle className="w-6 h-6 text-white" />,
      color: "emerald",
    },
    {
      title: "Initiated",
      count: getCount("Initiated"),
      icon: <QrCode className="w-6 h-6 text-white" />,
      color: "blue",
    },
    {
      title: "Occupied",
      count: getCount("Occupied"),
      icon: <User className="w-6 h-6 text-white" />,
      color: "rose",
    },
    {
      title: "Maintenance",
      count: getCount("Maintenance"),
      icon: <span className="text-lg text-white">🔧</span>,
      color: "amber",
    },
  ];

  return (
    <div className="p-5">
      <PageHeader
        title="Floor Management"
        description="View and manage seat arrangements on the floor"
      />

      {Array.isArray(seats) && seats.length > 0 &&(
        <div>

          {/* Stats Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 mb-8">
            {statsData.map(({ title, count, icon, color }) => (
              <StatisticsCard
                key={title}
                title={title}
                count={count}
                icon={icon}
                borderColor={`border-${color}-300`}
                countColor={`text-${color}-700`}
                bgGradient={`from-${color}-50 to-${color}-100/50`}
                iconBgColor={`bg-${color}-500`}
              />
            ))}
          </div>

          {/* Legend */}
          <div className="bg-white p-4 rounded-xl border border-gray-200 shadow-sm mb-6">
            <h3 className="text-lg font-semibold mb-3 text-gray-800">Legend</h3>
            <div className="flex flex-wrap gap-4">
              {legendItems.map(({ color, label }) => (
                <div key={label} className="flex items-center">
                  <div className={`w-4 h-4 bg-${color} rounded mr-2`}></div>
                  <span className="text-sm text-gray-600">{label}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Seats */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <SeatCard />
          </div>
        </div>
      )}
    </div>
  );
}
